module.exports = __webpack_public_path__ + "resources/img/img_ontune_vm_sms.8d9ada229d5562792e9cf56270f858da.png";